import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { useLeftBar } from "../../../context/LeftBar";
import { useLocation } from "react-router-dom";

function NavItem({ icon, muiIcon, name, path, subpages }) {
	const { leftBarOpened } = useLeftBar();
	const [showSubPageItems, setShowSubPageItems] = useState(false);
	const location = useLocation();

	useEffect(() => {
		if (
			subpages &&
			subpages.some((s) => s.url === location.pathname) &&
			!showSubPageItems
		) {
			setShowSubPageItems(true);
		}
	}, [location.pathname]);

	return (
		<li className="navItem">
			<NavLink
				to={path}
				activeClassName="active"
				isActive={(match, location) => {
					return subpages
						? subpages.some(
								(subpage) => subpage.url === location.pathname
						  )
						: path === location.pathname;
				}}
				onClick={(e) => {
					if (subpages) {
						e.preventDefault();
						setShowSubPageItems(!showSubPageItems);
					}
				}}
			>
				<div className="navItemNameContainer">
					{icon ? <i className={`${icon}`} /> : muiIcon}
					<span
						className={
							leftBarOpened
								? "navItemName"
								: "navItemName is-hidden"
						}
					>
						{name}
					</span>
				</div>
			</NavLink>
			{subpages && leftBarOpened && (
				<>
					<i
						className={
							showSubPageItems
								? "fal fa-angle-up"
								: "fal fa-angle-down"
						}
					/>
					<ul
						className={
							showSubPageItems
								? "subPagesList showSubPageItems"
								: "subPagesList"
						}
					>
						{showSubPageItems &&
							subpages.map((subpage) => (
								<li className="subNavItems" key={subpage.id}>
									<NavLink
										className="subNavLink"
										to={subpage.url}
										activeClassName="subItemActive"
									>
										{subpage.name}
									</NavLink>
								</li>
							))}
					</ul>
				</>
			)}
		</li>
	);
}

NavItem.defaultProps = {
	icon: "",
	name: "",
	path: "",
	subpages: undefined,
};

NavItem.propTypes = {
	icon: PropTypes.string,
	name: PropTypes.string,
	path: PropTypes.string,
	subpages: PropTypes.array,
};

export default NavItem;
